// V2 Reviews Swiper initialization
(function() {
  function initV2ReviewsSwiper() {
    document.querySelectorAll('[id^="v2-reviews-swiper-"]').forEach(function(el) {
      if (el.classList.contains('swiper-initialized')) return;

      const sectionId = el.id.replace('v2-reviews-swiper-', '');
      const section = el.closest('[data-section-id]');

      new Swiper(el, {
        slidesPerView: 1.05,
        spaceBetween: 12,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        speed: 7000,
        watchOverflow: true,
        navigation: {
          nextEl: section ? section.querySelector('.v2-reviews__nav-btn--next') : null,
          prevEl: section ? section.querySelector('.v2-reviews__nav-btn--prev') : null
        },
        pagination: {
          el: section ? section.querySelector('.v2-reviews__pagination') : null,
          clickable: true
        },
        breakpoints: {
          990: {
            slidesPerView: 3,
            spaceBetween: 18,
            loop: true
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV2ReviewsSwiper);
  } else {
    initV2ReviewsSwiper();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[id^="v2-reviews-swiper-"]')) {
      initV2ReviewsSwiper();
    }
  });
})();
